module.exports = __webpack_public_path__ + "static/media/y3.efbf741f.png";